export default "//cloud.imgsmail.ru/cloud.mail.ru/187531/img/build/editor/co-edit-alert-popup.jpg";